import React, { useState } from 'react'

import {
  ADD,
  Input,
  SubmitSuccess,
  useNotificationContext,
} from 'shared/components'
import { CustomArrow } from 'shared/components/Carousel/CarouselArrow'
import {
  emailValidator,
  handleReCaptchaVerify,
  handleTokenError,
} from 'shared/utils'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

import { SubscribersApi } from 'api'

import styles from './SubscribeForm.module.scss'

const api = new SubscribersApi()

export const SubscribeForm: React.FC = () => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setLoading] = useState(false)
  const [isShowReply, setShowReply] = useState(false)
  const { notificationsDispatch } = useNotificationContext()
  const { executeRecaptcha } = useGoogleReCaptcha()

  const checkEmail = (v?: string) => {
    const _email = v ? v : email
    const validationErr = emailValidator(_email)

    if (!_email.length) {
      return 'Заполните это поле'
    }

    if (validationErr.length) {
      return validationErr
    }

    return ''
  }

  const submit = () => {
    setLoading(true)

    handleReCaptchaVerify(executeRecaptcha)
      .then(token => {
        if (token) {
          api
            .postSubscribe({
              email,
              token,
            })
            .then(() => afterSubmitSuccess())
            .catch(() => setLoading(false))
        } else {
          handleTokenError()
        }
      })
      .catch(() => setLoading(false))
  }

  const afterSubmitSuccess = () => {
    setShowReply(true)
    setEmail('')
    setError('')

    notificationsDispatch({
      type: ADD,
      payload: {
        type: 'success',
        description: 'Вы успешно подписаны на нашу новостную рассылку',
      },
    })
  }

  const handleSubmitClick = () => {
    const _err = checkEmail()

    if (_err) {
      setError(_err)
    } else {
      submit()
    }
  }

  const renderSendBtn = () => {
    const icon = (
      <svg
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles['input__btn-arrow']}
      >
        <path
          d="M15.3744 8.30154C16.633 9.08409 16.633 10.9159 15.3744 11.6985L4.55604 18.4249C3.22379 19.2533 1.5 18.2952 1.5 16.7265L1.5 3.27353C1.5 1.70476 3.22379 0.746723 4.55604 1.57507L15.3744 8.30154Z"
          stroke="white"
          strokeWidth="2"
        />
      </svg>
    )

    return isLoading ? (
      <span className={styles['input__btn_loader']}>
        <i />
      </span>
    ) : (
      <>
        <CustomArrow
          isLeft={false}
          disabled={false}
          white={true}
          onClick={() => handleSubmitClick()}
          customClasses={styles.input__btn}
          activeHoverClasses={styles.active}
          customIcon={icon}
        />
        <button className={`${styles.input__btn} ${styles.mobile}`}>
          {icon}
        </button>
      </>
    )
  }

  return (
    <form
      className={styles.form}
      onSubmit={e => {
        e.preventDefault()
        handleSubmitClick()
      }}
    >
      <legend className={styles.title}>
        Подписка на новости и <span>пресс-релизы</span>
      </legend>
      <div className={styles.field__wrapper}>
        <Input
          value={email}
          onChange={e => {
            setEmail(e.target.value)
            setError(checkEmail(e.target.value))
          }}
          disabled={isLoading}
          onClear={() => setEmail('')}
          error={error.length > 0}
          success={email.length > 0 && error.length === 0}
          desc={error}
          inputClassName={styles.input}
          containerClasses={styles.input__container}
          placeholder="Email"
        />
        {renderSendBtn()}
      </div>

      {isShowReply && (
        <SubmitSuccess
          customClasses={styles.form__reply}
          isSmall
          onSvgAnimationEnd={() => {
            setShowReply(false)
            setLoading(false)
          }}
        />
      )}
    </form>
  )
}
